// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%; 
  padding: 40px 60px; 
  background-image: linear-gradient(180deg, rgba(8, 8, 8, 0.671), rgba(252, 252, 252, 0));
  display: flex; 
  transition: all 0.8s ease;
}

.header.scrolled {
  background-color: rgb(0, 0, 0); 
  padding: 20px 60px; 
}
.header.scrolled .app-logo{
  height: 80%;
}
.header .container .row{
  display: flex;
  justify-content: space-between;}

.header .left{
  display: flex;
  justify-content:space-between;
  align-items: center;
}
.app-logo{
  height: 100%;
  transition: all 0.8s ease;
}

.navbar {
  /* display: none; */
  width: 100%;
  position: fixed;
  z-index: 998;
  top: 0px;
  left: 100vw;
  background-color: #000;
  padding: 40px 15px;
  max-width: 100%;
  height: 105vh;
  overflow-y: scroll;
  transition: left .3s ease;
  
}


/* language dropdown */
.dropdown{
   list-style:none;
   margin: 0;
   padding-left: 0;
}
.down-arrow{
  height: 0.177864rem;
}
.dropdown-content {
   display: none;
   position: absolute;
   background-color: #f9f9f9;
   min-width: 160px;
   box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
   z-index: 1;
   transition: all ease 0.5s ;
 }
 .dropdown-content a {
   float: none;
   color: #191919;
   padding: 12px 16px;
   text-decoration: none;
   display: block;
   text-align: left;
   font-family: 'Inter';
   text-decoration: none;
    font-style: normal;
    font-weight: 500 !important;
    font-size: 14px !important;
    transition: ease-in 0.3s ;
 }
 .dropdown-content a:hover {
   background-color: #ddd;
   transition: ease-in 0.3s ;
 }
 .dropdown:hover .dropdown-content {
   display: block;
 }
 .header button{
   margin-left: 10px;
   background-color: transparent;
   border: none;
   padding: 0px;
 }
 .header button:hover{
  /* box-shadow: 0px 0px 13px 3px rgba(206, 236, 236, 0.7);
  border-radius: 50px;
  background-color: rgba(216, 243, 243, 0.411); */
  text-decoration: none;
 }
 .header button img{
  max-width: 30px !important;
}
 .header button:hover{
 font-weight: bold;
}
 .right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.right span{
  font-family: 'Montserrat', sans-serif;
  text-decoration: none;
  font-size: 13px;
  font-weight: 450;
  color: #fff;
  width: fit-content;
  white-space: normal;
}
 .nav-box {
  position: sticky;
  top: 96px;
  z-index: 998;
  width:inherit
}


.navbar ul {
  list-style: none;
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin: 0;
  width: 100%;
  border: unset;
  position: unset;
}
.navbar ul li {
  padding-right: 0;
  margin-right:27px;
  padding-left: 0;
  text-underline-offset: 5px;
  -webkit-text-decoration: 2.5px solid transparent underline;
          text-decoration: 2.5px solid transparent underline;
  transition:all ease 1s !important;

}


.navbar ul li:last-child {
  padding-right: 0;
}
.navbar ul li a {
  font-family: 'Montserrat', sans-serif;
  -webkit-text-decoration: 2.5px solid transparent underline;
          text-decoration: 2.5px solid transparent underline;
  font-size: 15px;
  font-weight: 400;
  color: #fff;
  width: fit-content;
  white-space: normal;
  text-underline-offset: 5px;
  transition:all ease 1s !important;
  background-color: transparent;

}
.navbar ul li:hover{
  -webkit-text-decoration: 2.5px solid #FAEC24 underline;
          text-decoration: 2.5px solid #FAEC24 underline;
  cursor: pointer;
} 

.navbar ul li.active{
  -webkit-text-decoration: 2.5px solid #FAEC24 underline;
          text-decoration: 2.5px solid #FAEC24 underline;
}


.dropdown {
  list-style: none;
}
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.dropdown-content a {
  float: none;
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  text-align: left;
}
.dropdown-content a:hover {
  background-color: #ddd;
}
.dropdown:hover .dropdown-content {
  display: block;
}
.sub-list {
  display: none;
}
ul li a:hover~.sub-list {
  display: block;
}
.collapse-side-nav {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #FFF;
  padding: 10px;
  height: 100vh;
}
.collapse-side-nav ul {
  display: block;
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}
.collapse-side-nav ul li a {
  display: block;
  text-align: left;
}
.collapse-side-nav ul li a {
  text-decoration: none;
  font-size: 0.889322rem;
  font-weight: 700;
  color: #000000;
  width: fit-content;
}
.collapse-side-nav .main-menu-item {
  padding: 10px 0;
  min-width: 280px;
}
.collapse-side-nav .sub-menu-item {
  font-weight: 200;
}
/* toggler button animation */
.navbar-toggler {
  width: fit-content;
  border: none;
  background: transparent !important;
  display: block;
  position: relative;
  transition: right 1s ease; 
  z-index: 999;
  padding: 0.25rem 0rem;
}
.navbar-toggler:hover {
  background: transparent !important;
  transition: background 1s ease; 
}
.navbar-toggler .icon-bar {
  width: 30px;
  height: 4px;
  background-color: #ffffff;
  margin-top: 6px;
  border-radius: 3px;
  display: block;
  transition: all ease 0.3s; 
  margin-left: auto;
}
.navbar-toggler .top-bar {
  transform: rotate(45deg);
  transform-origin: -40% -110%;
  transition: transform 0.3s ease, background-color 0.3s ease; 
}

.navbar-toggler .middle-bar {
  opacity: 0;
  position: relative;
  left: -9px;
  transition: opacity 0.3s ease;
}

.navbar-toggler .bottom-bar {
  position: relative;
  left: -18px;
  transform: rotate(-45deg);
  transform-origin: 50% -190%;
  transition: transform 0.3s ease, background-color 0.3s ease; 
}

.navbar-toggler.collapsed .top-bar {
  transform: rotate(0);
  background-color: #f6f6f6;
  
}

.navbar-toggler.collapsed .middle-bar {
  opacity: 1;
  background-color: #f6f6f6;

}

.navbar-toggler.collapsed .bottom-bar {
  transform: rotate(0);
  background-color:  #f6f6f6;
}
.cart{
  background-color: transparent;
  border: none;
  margin-top: 6px;
}
button{
  font-weight: 600;
}
/* toggler button animation ends */


@media (min-width:768px) and (max-width: 992px) {
  /* .header {
    padding-top: 12px; 
    background-color: rgba(0, 0, 0, 0.274);
    position: sticky;
    top: 0;
    padding-bottom: 10px;
  } */
  .header {
    background-color: rgba(0, 0, 0, 0.274);
    padding-top: 12px; 
    position: sticky;
    top: 0;
    padding:  20px!important;
    padding-bottom: 10px ;
  }
  .header .header-container{
    padding: 0;
  }
  .header.scrolled {
    background-color: rgb(0, 0, 0);
    padding: 17px !important;
  }
  .header button{
    display: none;
     }
  
  .sns-icon{
    display: block !important;
  }
  .social-icons-container {
      display: flex;
      align-items: center; 
      color: #FFF;
      font-size: 17px;
      font-weight: 380;
      font-family: 'Montserrat',sans-serif;
  }
  .social-icons-container .sns-xt{
    padding-right: 1rem;
  }

  .social-icons-container a {
      margin-right: 10px; 
  }
  .navbar-toggler .icon-bar {
    margin-top: 5px;
  }
  .navbar-toggler .top-bar {
    width: 20px;
    transform-origin:-78% -83%;
  }
   .navbar-toggler .middle-bar {
     width: 20px;
     left: -8PX;
   }
   .navbar-toggler .bottom-bar {
     width: 20px;
     left: -16px;
     position: relative;
   }
   .navbar-toggler .bottom-bar {
    transform: rotate(-45deg);
    transform-origin: 50% -134%;
    transition: transform 0.3s ease, background-color 0.3s ease; 
  }
  .navbar ul li:hover{
    text-decoration: none;
  }
  .navbar ul li:active{
    text-decoration: none;
  }


   .header .left{
     display: flex;
     justify-content:space-between;
     align-items: flex-end;
     padding: 2px 2px;
   }
  .signup-btn{
    margin-left: 10px;
  }
  .language-dropdown{
    width: fit-content;
    margin-top: 10px !important;

  }
  hr.solid {
    border-top: 2px solid #bbb;
    width: 90%;
  }
    .header .right {
    
    display: none;
    }

  .app-logo{
    position: relative;
    /* z-index: 999; */
  }
  
    .navbar-toggler {
      display: block;
      margin-left: 0px;
  }

  .collapse-side-nav {
      display: block;
  }

  .navbar ul {
      display: block;
      /* width:unset; */
      margin-top: 50px;
      padding-left: 20px;
  }
  .language-dropdown {
      width: fit-content !important;
  }
  .navbar ul li {
    margin-bottom: 20px;
    
    border-bottom: 1px solid #FFF;
    width:97%;
    text-align: left !important;
  }

  .navbar ul li a {
    position: relative;
    bottom: 10px;
    width:100%;
    font-size: 17px;
    line-height: 55px;
    font-weight: 380;
  } 
  .sns-item {
    position: relative;
    bottom: 10px;
    width:100%;
    font-size: 17px;
    line-height: 55px;
    font-weight: 380;
  } 
  .social-icons {
    display: flex;
    align-items: center;
  }
  button{
    font-size: 15px;
}
  .sns-icon {
    display: block;
      margin-right: 10px; /* Adjust as needed */
  }
  .navbar {
    /* display: none; */
    width: 100%;
    position: fixed;
    z-index: 998;
    top: 0px;
    left: 100vw;
    background-color: #000;
    padding: 40px 15px;
    max-width: 100%;
    height: 105vh;
    overflow-y: scroll;
    transition: left .3s ease;
    
}
  .nav-sub-box {
      display: block;
  }

  .nav-sub-box {
      width: 100%;
      display: block;
      margin-right: 0;
      padding: 0;
      position: static;

  }

  .side-display {
      display: none;
  }
  .navbar ul li.active{
    text-decoration:none;
  }


}
/* }
 @media (max-width: 767px) {
  .header{
    position: sticky;
    top: 0;
    background-color: transparent;
    border-bottom: unset;
    z-index:999
    
  }
  .app-logo {
    height: 3rem;
}

.header .top {
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 24px;
  padding-left: 24px;
}
  .right button{
    padding: .5rem 1rem;
   
  }
  .navbar {
    top: 0px;
    width: 100vw;
    height: calc(100vh - 137px);

}
} */


 /*responssive for Mobile*/

 @media (max-width: 576px) {

  .app-logo{
    height: 45px;
    position: relative;
    /* z-index: 999; */
    padding-top: 5px;
  }
  .header{
    position: sticky;
    top: 0;
    background-color:rgba(0, 0, 0, 0.274);
    border-bottom: unset;
    z-index:999;
    padding:15px 5px;
  }
  .header.scrolled {
    background-color: rgb(0, 0, 0);
    padding:12px 5px;
  }
  .header.scrolled .app-logo{
    height: 40px;
  }
  .header button{
   display: none;
  }
  /* .header .logo{
    text-align: left;
  } */
  .navbar-toggler .icon-bar {
    margin-top: 5px;
  }
  .navbar-toggler .top-bar {
    width: 17px;
    transform-origin:-78% -83%;
  }
  .header .right{
    display: none;
  }
  .navbar-toggler .middle-bar {
    width: 17px;
    left: -7PX;
  }
  .navbar ul li:hover{
    text-decoration: none;
  }
  .navbar ul li:active{
    text-decoration: none;
  }
  .navbar {
    /* display: none; */
    width: 0;
    position: fixed;
    z-index: 998;
    top: 0px;
    left: 0px;
    background-color: #000;
    padding: 40px 15px;
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
    transition: all .3s ease;
}
  .navbar-toggler .bottom-bar {
    width: 17px;
    left: -14px;
    position: relative;
}
  .navbar-toggler {
    display: block;
    padding-right: 10px;
}
.navbar-toggler .cart{
  display: block;
}
.navbar ul li.active{
  text-decoration: none;
}

.sns-icon{
  display: block !important;
}
.social-icons-container {
    display: flex;
    align-items: center; 
    color: #FFF;
    font-size: 16px;
    font-weight: 380;
    font-family: 'Montserrat',sans-serif;
    margin-top: -1rem;
}
.social-icons-container .sns-xt{
  padding-right: 1rem;
}

.social-icons-container a {
    margin-right: 10px; 
}
  .header .left{
    display: flex;
    justify-content:space-between;
    align-items: flex-end;

    padding: 0px 10px;
  }
  .navbar-toggler .icon-bar {
    height: 3px;
  }
  .navbar ul {
    display: block;
    /* width:unset; */
    margin-top: 55px;
    padding-left: 20px;
}
.language-dropdown {
    width: fit-content !important;
}
.navbar ul li {
    margin-bottom: 35px;
    border-bottom: 1px solid #FFF;
    width:90%;
    text-align: left;
}
.dropdown:hover .dropdown-content {
  display: block;
}
.navbar ul li a {
  position: relative;
  bottom: 15px;
  width:100%;
  font-size: 16px;
  font-weight: 380;
}
.nav-sub-box {
    display: block;
}
.nav-sub-box {
    width: 100%;
    display: block;
    margin-right: 0;
    padding: 0;
    position: static;
}
.side-display {
    display: none;
} 
  
}
@media (min-width:1400px){
  .navbar ul li a {
    font-size: 15px;
  }
  .right span{
    font-size: 15px;
  }
  .navbar ul li {
    margin-right:34px;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/common-componets/Header.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uFAAuF;EACvF,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B,CAAC;;AAEjC;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yBAAyB;;AAE3B;;;AAGA,sBAAsB;AACtB;GACG,eAAe;GACf,SAAS;GACT,eAAe;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;GACG,aAAa;GACb,kBAAkB;GAClB,yBAAyB;GACzB,gBAAgB;GAChB,4CAA4C;GAC5C,UAAU;GACV,0BAA0B;CAC5B;CACA;GACE,WAAW;GACX,cAAc;GACd,kBAAkB;GAClB,qBAAqB;GACrB,cAAc;GACd,gBAAgB;GAChB,oBAAoB;GACpB,qBAAqB;IACpB,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;CAC5B;CACA;GACE,sBAAsB;GACtB,yBAAyB;CAC3B;CACA;GACE,cAAc;CAChB;CACA;GACE,iBAAiB;GACjB,6BAA6B;GAC7B,YAAY;GACZ,YAAY;CACd;CACA;EACC;;iDAE+C;EAC/C,qBAAqB;CACtB;CACA;EACC,0BAA0B;AAC5B;CACC;CACA,iBAAiB;AAClB;CACC;EACC,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;CACC;EACC,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ;AACF;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,SAAS;EACT,WAAW;EACX,aAAa;EACb,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,0DAAkD;UAAlD,kDAAkD;EAClD,iCAAiC;;AAEnC;;;AAGA;EACE,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,0DAAkD;UAAlD,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,iCAAiC;EACjC,6BAA6B;;AAE/B;AACA;EACE,sDAA8C;UAA9C,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,sDAA8C;UAA9C,8CAA8C;AAChD;;;AAGA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,aAAa;EACb,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,2DAA2D;AAC7D;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,2BAA2B;EAC3B,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;;AAE3B;;AAEA;EACE,UAAU;EACV,yBAAyB;;AAE3B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA,kCAAkC;;;AAGlC;EACE;;;;;;KAMG;EACH;IACE,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;IAChB,MAAM;IACN,wBAAwB;IACxB,qBAAqB;EACvB;EACA;IACE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,wBAAwB;EAC1B;EACA;IACE,aAAa;KACZ;;EAEH;IACE,yBAAyB;EAC3B;EACA;MACI,aAAa;MACb,mBAAmB;MACnB,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,oCAAoC;EACxC;EACA;IACE,mBAAmB;EACrB;;EAEA;MACI,kBAAkB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,0BAA0B;EAC5B;GACC;KACE,WAAW;KACX,UAAU;GACZ;GACA;KACE,WAAW;KACX,WAAW;KACX,kBAAkB;GACpB;GACA;IACC,yBAAyB;IACzB,2BAA2B;IAC3B,2DAA2D;EAC7D;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;;;GAGC;KACE,aAAa;KACb,6BAA6B;KAC7B,qBAAqB;KACrB,gBAAgB;GAClB;EACD;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,2BAA2B;;EAE7B;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;IACE;;IAEA,aAAa;IACb;;EAEF;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;IAEE;MACE,cAAc;MACd,gBAAgB;EACpB;;EAEA;MACI,cAAc;EAClB;;EAEA;MACI,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,kBAAkB;EACtB;EACA;MACI,6BAA6B;EACjC;EACA;IACE,mBAAmB;;IAEnB,6BAA6B;IAC7B,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,eAAe;AACnB;EACE;IACE,cAAc;MACZ,kBAAkB,EAAE,qBAAqB;EAC7C;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,QAAQ;IACR,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,yBAAyB;;AAE7B;EACE;MACI,cAAc;EAClB;;EAEA;MACI,WAAW;MACX,cAAc;MACd,eAAe;MACf,UAAU;MACV,gBAAgB;;EAEpB;;EAEA;MACI,aAAa;EACjB;EACA;IACE,oBAAoB;EACtB;;;AAGF;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8BG;;;CAGF,yBAAyB;;CAEzB;;EAEC;IACE,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,MAAM;IACN,qCAAqC;IACrC,oBAAoB;IACpB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;GACC,aAAa;EACd;EACA;;KAEG;EACH;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,wBAAwB;AAC5B;EACE;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;EACE;IACE,cAAc;IACd,mBAAmB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,oCAAoC;IACpC,iBAAiB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;IACI,kBAAkB;AACtB;EACE;IACE,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;;IAErB,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,cAAc;IACd,eAAe;IACf,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;;AAEA;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;;AAEF","sourcesContent":[".header {\r\n  position: fixed;\r\n  top: 0;\r\n  z-index: 999;\r\n  width: 100%; \r\n  padding: 40px 60px; \r\n  background-image: linear-gradient(180deg, rgba(8, 8, 8, 0.671), rgba(252, 252, 252, 0));\r\n  display: flex; \r\n  transition: all 0.8s ease;\r\n}\r\n\r\n.header.scrolled {\r\n  background-color: rgb(0, 0, 0); \r\n  padding: 20px 60px; \r\n}\r\n.header.scrolled .app-logo{\r\n  height: 80%;\r\n}\r\n.header .container .row{\r\n  display: flex;\r\n  justify-content: space-between;}\r\n\r\n.header .left{\r\n  display: flex;\r\n  justify-content:space-between;\r\n  align-items: center;\r\n}\r\n.app-logo{\r\n  height: 100%;\r\n  transition: all 0.8s ease;\r\n}\r\n\r\n.navbar {\r\n  /* display: none; */\r\n  width: 100%;\r\n  position: fixed;\r\n  z-index: 998;\r\n  top: 0px;\r\n  left: 100vw;\r\n  background-color: #000;\r\n  padding: 40px 15px;\r\n  max-width: 100%;\r\n  height: 105vh;\r\n  overflow-y: scroll;\r\n  transition: left .3s ease;\r\n  \r\n}\r\n\r\n\r\n/* language dropdown */\r\n.dropdown{\r\n   list-style:none;\r\n   margin: 0;\r\n   padding-left: 0;\r\n}\r\n.down-arrow{\r\n  height: 0.177864rem;\r\n}\r\n.dropdown-content {\r\n   display: none;\r\n   position: absolute;\r\n   background-color: #f9f9f9;\r\n   min-width: 160px;\r\n   box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\r\n   z-index: 1;\r\n   transition: all ease 0.5s ;\r\n }\r\n .dropdown-content a {\r\n   float: none;\r\n   color: #191919;\r\n   padding: 12px 16px;\r\n   text-decoration: none;\r\n   display: block;\r\n   text-align: left;\r\n   font-family: 'Inter';\r\n   text-decoration: none;\r\n    font-style: normal;\r\n    font-weight: 500 !important;\r\n    font-size: 14px !important;\r\n    transition: ease-in 0.3s ;\r\n }\r\n .dropdown-content a:hover {\r\n   background-color: #ddd;\r\n   transition: ease-in 0.3s ;\r\n }\r\n .dropdown:hover .dropdown-content {\r\n   display: block;\r\n }\r\n .header button{\r\n   margin-left: 10px;\r\n   background-color: transparent;\r\n   border: none;\r\n   padding: 0px;\r\n }\r\n .header button:hover{\r\n  /* box-shadow: 0px 0px 13px 3px rgba(206, 236, 236, 0.7);\r\n  border-radius: 50px;\r\n  background-color: rgba(216, 243, 243, 0.411); */\r\n  text-decoration: none;\r\n }\r\n .header button img{\r\n  max-width: 30px !important;\r\n}\r\n .header button:hover{\r\n font-weight: bold;\r\n}\r\n .right{\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n}\r\n.right span{\r\n  font-family: 'Montserrat', sans-serif;\r\n  text-decoration: none;\r\n  font-size: 13px;\r\n  font-weight: 450;\r\n  color: #fff;\r\n  width: fit-content;\r\n  white-space: normal;\r\n}\r\n .nav-box {\r\n  position: sticky;\r\n  top: 96px;\r\n  z-index: 998;\r\n  width:inherit\r\n}\r\n\r\n\r\n.navbar ul {\r\n  list-style: none;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 0;\r\n  margin: 0;\r\n  width: 100%;\r\n  border: unset;\r\n  position: unset;\r\n}\r\n.navbar ul li {\r\n  padding-right: 0;\r\n  margin-right:27px;\r\n  padding-left: 0;\r\n  text-underline-offset: 5px;\r\n  text-decoration: 2.5px solid transparent underline;\r\n  transition:all ease 1s !important;\r\n\r\n}\r\n\r\n\r\n.navbar ul li:last-child {\r\n  padding-right: 0;\r\n}\r\n.navbar ul li a {\r\n  font-family: 'Montserrat', sans-serif;\r\n  text-decoration: 2.5px solid transparent underline;\r\n  font-size: 15px;\r\n  font-weight: 400;\r\n  color: #fff;\r\n  width: fit-content;\r\n  white-space: normal;\r\n  text-underline-offset: 5px;\r\n  transition:all ease 1s !important;\r\n  background-color: transparent;\r\n\r\n}\r\n.navbar ul li:hover{\r\n  text-decoration: 2.5px solid #FAEC24 underline;\r\n  cursor: pointer;\r\n} \r\n\r\n.navbar ul li.active{\r\n  text-decoration: 2.5px solid #FAEC24 underline;\r\n}\r\n\r\n\r\n.dropdown {\r\n  list-style: none;\r\n}\r\n.dropdown-content {\r\n  display: none;\r\n  position: absolute;\r\n  background-color: #f9f9f9;\r\n  min-width: 160px;\r\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\r\n  z-index: 1;\r\n}\r\n.dropdown-content a {\r\n  float: none;\r\n  color: black;\r\n  padding: 12px 16px;\r\n  text-decoration: none;\r\n  display: block;\r\n  text-align: left;\r\n}\r\n.dropdown-content a:hover {\r\n  background-color: #ddd;\r\n}\r\n.dropdown:hover .dropdown-content {\r\n  display: block;\r\n}\r\n.sub-list {\r\n  display: none;\r\n}\r\nul li a:hover~.sub-list {\r\n  display: block;\r\n}\r\n.collapse-side-nav {\r\n  display: none;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  background-color: #FFF;\r\n  padding: 10px;\r\n  height: 100vh;\r\n}\r\n.collapse-side-nav ul {\r\n  display: block;\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  width: 100%;\r\n}\r\n.collapse-side-nav ul li a {\r\n  display: block;\r\n  text-align: left;\r\n}\r\n.collapse-side-nav ul li a {\r\n  text-decoration: none;\r\n  font-size: 0.889322rem;\r\n  font-weight: 700;\r\n  color: #000000;\r\n  width: fit-content;\r\n}\r\n.collapse-side-nav .main-menu-item {\r\n  padding: 10px 0;\r\n  min-width: 280px;\r\n}\r\n.collapse-side-nav .sub-menu-item {\r\n  font-weight: 200;\r\n}\r\n/* toggler button animation */\r\n.navbar-toggler {\r\n  width: fit-content;\r\n  border: none;\r\n  background: transparent !important;\r\n  display: block;\r\n  position: relative;\r\n  transition: right 1s ease; \r\n  z-index: 999;\r\n  padding: 0.25rem 0rem;\r\n}\r\n.navbar-toggler:hover {\r\n  background: transparent !important;\r\n  transition: background 1s ease; \r\n}\r\n.navbar-toggler .icon-bar {\r\n  width: 30px;\r\n  height: 4px;\r\n  background-color: #ffffff;\r\n  margin-top: 6px;\r\n  border-radius: 3px;\r\n  display: block;\r\n  transition: all ease 0.3s; \r\n  margin-left: auto;\r\n}\r\n.navbar-toggler .top-bar {\r\n  transform: rotate(45deg);\r\n  transform-origin: -40% -110%;\r\n  transition: transform 0.3s ease, background-color 0.3s ease; \r\n}\r\n\r\n.navbar-toggler .middle-bar {\r\n  opacity: 0;\r\n  position: relative;\r\n  left: -9px;\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.navbar-toggler .bottom-bar {\r\n  position: relative;\r\n  left: -18px;\r\n  transform: rotate(-45deg);\r\n  transform-origin: 50% -190%;\r\n  transition: transform 0.3s ease, background-color 0.3s ease; \r\n}\r\n\r\n.navbar-toggler.collapsed .top-bar {\r\n  transform: rotate(0);\r\n  background-color: #f6f6f6;\r\n  \r\n}\r\n\r\n.navbar-toggler.collapsed .middle-bar {\r\n  opacity: 1;\r\n  background-color: #f6f6f6;\r\n\r\n}\r\n\r\n.navbar-toggler.collapsed .bottom-bar {\r\n  transform: rotate(0);\r\n  background-color:  #f6f6f6;\r\n}\r\n.cart{\r\n  background-color: transparent;\r\n  border: none;\r\n  margin-top: 6px;\r\n}\r\nbutton{\r\n  font-weight: 600;\r\n}\r\n/* toggler button animation ends */\r\n\r\n\r\n@media (min-width:768px) and (max-width: 992px) {\r\n  /* .header {\r\n    padding-top: 12px; \r\n    background-color: rgba(0, 0, 0, 0.274);\r\n    position: sticky;\r\n    top: 0;\r\n    padding-bottom: 10px;\r\n  } */\r\n  .header {\r\n    background-color: rgba(0, 0, 0, 0.274);\r\n    padding-top: 12px; \r\n    position: sticky;\r\n    top: 0;\r\n    padding:  20px!important;\r\n    padding-bottom: 10px ;\r\n  }\r\n  .header .header-container{\r\n    padding: 0;\r\n  }\r\n  .header.scrolled {\r\n    background-color: rgb(0, 0, 0);\r\n    padding: 17px !important;\r\n  }\r\n  .header button{\r\n    display: none;\r\n     }\r\n  \r\n  .sns-icon{\r\n    display: block !important;\r\n  }\r\n  .social-icons-container {\r\n      display: flex;\r\n      align-items: center; \r\n      color: #FFF;\r\n      font-size: 17px;\r\n      font-weight: 380;\r\n      font-family: 'Montserrat',sans-serif;\r\n  }\r\n  .social-icons-container .sns-xt{\r\n    padding-right: 1rem;\r\n  }\r\n\r\n  .social-icons-container a {\r\n      margin-right: 10px; \r\n  }\r\n  .navbar-toggler .icon-bar {\r\n    margin-top: 5px;\r\n  }\r\n  .navbar-toggler .top-bar {\r\n    width: 20px;\r\n    transform-origin:-78% -83%;\r\n  }\r\n   .navbar-toggler .middle-bar {\r\n     width: 20px;\r\n     left: -8PX;\r\n   }\r\n   .navbar-toggler .bottom-bar {\r\n     width: 20px;\r\n     left: -16px;\r\n     position: relative;\r\n   }\r\n   .navbar-toggler .bottom-bar {\r\n    transform: rotate(-45deg);\r\n    transform-origin: 50% -134%;\r\n    transition: transform 0.3s ease, background-color 0.3s ease; \r\n  }\r\n  .navbar ul li:hover{\r\n    text-decoration: none;\r\n  }\r\n  .navbar ul li:active{\r\n    text-decoration: none;\r\n  }\r\n\r\n\r\n   .header .left{\r\n     display: flex;\r\n     justify-content:space-between;\r\n     align-items: flex-end;\r\n     padding: 2px 2px;\r\n   }\r\n  .signup-btn{\r\n    margin-left: 10px;\r\n  }\r\n  .language-dropdown{\r\n    width: fit-content;\r\n    margin-top: 10px !important;\r\n\r\n  }\r\n  hr.solid {\r\n    border-top: 2px solid #bbb;\r\n    width: 90%;\r\n  }\r\n    .header .right {\r\n    \r\n    display: none;\r\n    }\r\n\r\n  .app-logo{\r\n    position: relative;\r\n    /* z-index: 999; */\r\n  }\r\n  \r\n    .navbar-toggler {\r\n      display: block;\r\n      margin-left: 0px;\r\n  }\r\n\r\n  .collapse-side-nav {\r\n      display: block;\r\n  }\r\n\r\n  .navbar ul {\r\n      display: block;\r\n      /* width:unset; */\r\n      margin-top: 50px;\r\n      padding-left: 20px;\r\n  }\r\n  .language-dropdown {\r\n      width: fit-content !important;\r\n  }\r\n  .navbar ul li {\r\n    margin-bottom: 20px;\r\n    \r\n    border-bottom: 1px solid #FFF;\r\n    width:97%;\r\n    text-align: left !important;\r\n  }\r\n\r\n  .navbar ul li a {\r\n    position: relative;\r\n    bottom: 10px;\r\n    width:100%;\r\n    font-size: 17px;\r\n    line-height: 55px;\r\n    font-weight: 380;\r\n  } \r\n  .sns-item {\r\n    position: relative;\r\n    bottom: 10px;\r\n    width:100%;\r\n    font-size: 17px;\r\n    line-height: 55px;\r\n    font-weight: 380;\r\n  } \r\n  .social-icons {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  button{\r\n    font-size: 15px;\r\n}\r\n  .sns-icon {\r\n    display: block;\r\n      margin-right: 10px; /* Adjust as needed */\r\n  }\r\n  .navbar {\r\n    /* display: none; */\r\n    width: 100%;\r\n    position: fixed;\r\n    z-index: 998;\r\n    top: 0px;\r\n    left: 100vw;\r\n    background-color: #000;\r\n    padding: 40px 15px;\r\n    max-width: 100%;\r\n    height: 105vh;\r\n    overflow-y: scroll;\r\n    transition: left .3s ease;\r\n    \r\n}\r\n  .nav-sub-box {\r\n      display: block;\r\n  }\r\n\r\n  .nav-sub-box {\r\n      width: 100%;\r\n      display: block;\r\n      margin-right: 0;\r\n      padding: 0;\r\n      position: static;\r\n\r\n  }\r\n\r\n  .side-display {\r\n      display: none;\r\n  }\r\n  .navbar ul li.active{\r\n    text-decoration:none;\r\n  }\r\n\r\n\r\n}\r\n/* }\r\n @media (max-width: 767px) {\r\n  .header{\r\n    position: sticky;\r\n    top: 0;\r\n    background-color: transparent;\r\n    border-bottom: unset;\r\n    z-index:999\r\n    \r\n  }\r\n  .app-logo {\r\n    height: 3rem;\r\n}\r\n\r\n.header .top {\r\n  padding-top: 1rem;\r\n  padding-bottom: 1rem;\r\n  padding-left: 24px;\r\n  padding-left: 24px;\r\n}\r\n  .right button{\r\n    padding: .5rem 1rem;\r\n   \r\n  }\r\n  .navbar {\r\n    top: 0px;\r\n    width: 100vw;\r\n    height: calc(100vh - 137px);\r\n\r\n}\r\n} */\r\n\r\n\r\n /*responssive for Mobile*/\r\n\r\n @media (max-width: 576px) {\r\n\r\n  .app-logo{\r\n    height: 45px;\r\n    position: relative;\r\n    /* z-index: 999; */\r\n    padding-top: 5px;\r\n  }\r\n  .header{\r\n    position: sticky;\r\n    top: 0;\r\n    background-color:rgba(0, 0, 0, 0.274);\r\n    border-bottom: unset;\r\n    z-index:999;\r\n    padding:15px 5px;\r\n  }\r\n  .header.scrolled {\r\n    background-color: rgb(0, 0, 0);\r\n    padding:12px 5px;\r\n  }\r\n  .header.scrolled .app-logo{\r\n    height: 40px;\r\n  }\r\n  .header button{\r\n   display: none;\r\n  }\r\n  /* .header .logo{\r\n    text-align: left;\r\n  } */\r\n  .navbar-toggler .icon-bar {\r\n    margin-top: 5px;\r\n  }\r\n  .navbar-toggler .top-bar {\r\n    width: 17px;\r\n    transform-origin:-78% -83%;\r\n  }\r\n  .header .right{\r\n    display: none;\r\n  }\r\n  .navbar-toggler .middle-bar {\r\n    width: 17px;\r\n    left: -7PX;\r\n  }\r\n  .navbar ul li:hover{\r\n    text-decoration: none;\r\n  }\r\n  .navbar ul li:active{\r\n    text-decoration: none;\r\n  }\r\n  .navbar {\r\n    /* display: none; */\r\n    width: 0;\r\n    position: fixed;\r\n    z-index: 998;\r\n    top: 0px;\r\n    left: 0px;\r\n    background-color: #000;\r\n    padding: 40px 15px;\r\n    width: 100%;\r\n    height: 100vh;\r\n    overflow-y: scroll;\r\n    transition: all .3s ease;\r\n}\r\n  .navbar-toggler .bottom-bar {\r\n    width: 17px;\r\n    left: -14px;\r\n    position: relative;\r\n}\r\n  .navbar-toggler {\r\n    display: block;\r\n    padding-right: 10px;\r\n}\r\n.navbar-toggler .cart{\r\n  display: block;\r\n}\r\n.navbar ul li.active{\r\n  text-decoration: none;\r\n}\r\n\r\n.sns-icon{\r\n  display: block !important;\r\n}\r\n.social-icons-container {\r\n    display: flex;\r\n    align-items: center; \r\n    color: #FFF;\r\n    font-size: 16px;\r\n    font-weight: 380;\r\n    font-family: 'Montserrat',sans-serif;\r\n    margin-top: -1rem;\r\n}\r\n.social-icons-container .sns-xt{\r\n  padding-right: 1rem;\r\n}\r\n\r\n.social-icons-container a {\r\n    margin-right: 10px; \r\n}\r\n  .header .left{\r\n    display: flex;\r\n    justify-content:space-between;\r\n    align-items: flex-end;\r\n\r\n    padding: 0px 10px;\r\n  }\r\n  .navbar-toggler .icon-bar {\r\n    height: 3px;\r\n  }\r\n  .navbar ul {\r\n    display: block;\r\n    /* width:unset; */\r\n    margin-top: 55px;\r\n    padding-left: 20px;\r\n}\r\n.language-dropdown {\r\n    width: fit-content !important;\r\n}\r\n.navbar ul li {\r\n    margin-bottom: 35px;\r\n    border-bottom: 1px solid #FFF;\r\n    width:90%;\r\n    text-align: left;\r\n}\r\n.dropdown:hover .dropdown-content {\r\n  display: block;\r\n}\r\n.navbar ul li a {\r\n  position: relative;\r\n  bottom: 15px;\r\n  width:100%;\r\n  font-size: 16px;\r\n  font-weight: 380;\r\n}\r\n.nav-sub-box {\r\n    display: block;\r\n}\r\n.nav-sub-box {\r\n    width: 100%;\r\n    display: block;\r\n    margin-right: 0;\r\n    padding: 0;\r\n    position: static;\r\n}\r\n.side-display {\r\n    display: none;\r\n} \r\n  \r\n}\r\n@media (min-width:1400px){\r\n  .navbar ul li a {\r\n    font-size: 15px;\r\n  }\r\n  .right span{\r\n    font-size: 15px;\r\n  }\r\n  .navbar ul li {\r\n    margin-right:34px;\r\n  }\r\n  \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
